import React from 'react';

interface LinePlusIconProps {
  size?: number;
  color?: string;
}

export const LinePlusIcon: React.FC<LinePlusIconProps> = ({ size = 24, color = '#686868' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 4V20" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M20 12L4 12" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};
